import {
  Divider,
  Button,
  Table,
  Modal,
  Form,
  Tooltip,
  Space,
  Popconfirm,
  Input,
  message,
  InputNumber,
} from "antd";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import * as Helper from "../../helpers";
import {
  deleteEsmaulHusna,
  getEsmaulHusnalar,
  insertEsmaulHusna,
  updateEsmaulHusna,
} from "../../store/slices/esmaulHusnaSlice";
const { TextArea } = Input;

const EsmaulHusnalar = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getEsmaulHusnalar({
        sort: [
          {
            field: "SiraNo",
            dir: "asc",
          },
        ],
      })
    );
  }, [dispatch]);

  const esmaulHusna = useSelector((state) => state.esmaulHusna);
  const esmaulHusnalar = useSelector(
    (state) => state.esmaulHusna.esmaulHusnalar
  );

  const [filteredInfo, setFilteredInfo] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();
    setEditMode(false);
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditMode(true);
    form.setFieldsValue({
      id: record.id,
      isim: record.isim,
      anlami: record.anlami,
      siraNo: record.siraNo,
      not: record.not,
    });
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((record) => {
        if (editMode) {
          let body = {
            id: record.id,
            isim: record.isim,
            anlami: record.anlami,
            siraNo: record.siraNo,
            not: record.not,
          };
          dispatch(updateEsmaulHusna(body))
            .unwrap()
            .then((result) => {
              dispatch(
                getEsmaulHusnalar({
                  sort: [
                    {
                      field: "SiraNo",
                      dir: "asc",
                    },
                  ],
                })
              );
              setIsModalVisible(false);
              form.resetFields();
              setEditMode(false);
              message.success("Kayıt güncellendi");
            })
            .catch(() => {
              // handle error here
            });
        } else {
          let body = {
            isim: record.isim,
            anlami: record.anlami,
            siraNo: record.siraNo,
            not: record.not
          };
          dispatch(insertEsmaulHusna(body))
            .unwrap()
            .then((result) => {
              dispatch(
                getEsmaulHusnalar({
                  sort: [
                    {
                      field: "SiraNo",
                      dir: "asc",
                    },
                  ],
                })
              );
              setIsModalVisible(false);
              form.resetFields();
              setEditMode(false);
              message.success("Kayıt eklendi");
            })
            .catch(() => {
              // handle error here
            });
        }
      })
      .catch((info) => {});
  };

  const handleDelete = (id) => {
    let body = { id: id };
    dispatch(deleteEsmaulHusna(body))
      .unwrap()
      .then((result) => {
        dispatch(
          getEsmaulHusnalar({
            sort: [
              {
                field: "SiraNo",
                dir: "asc",
              },
            ],
          })
        );
        message.success("Kayıt silindi");
      })
      .catch((rejectedValueOrSerializedError) => {
        // handle error here
      });
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
  };
  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
  };

  return (
    <div>
      <Button
        onClick={() => showModal()}
        type="primary"
        style={{
          marginBottom: 16,
        }}
      >
        Ekle
      </Button>
      <Divider />

      <Table
        loading={esmaulHusna.loading}
        dataSource={esmaulHusnalar.items}
        rowKey="id"
        onChange={handleChange}
        columns={[
          {
            title: "Id",
            dataIndex: "id",
            key: "id",
            sorter: (a, b) => a.id - b.id,
            defaultSortOrder: "descend",
            ellipsis: true,

          },
          {
            title: "Sıra",
            dataIndex: "siraNo",
            key: "siraNo",
            filters: Helper.filter(esmaulHusnalar.items, "siraNo"),
            filteredValue: filteredInfo.siraNo || null,
            onFilter: (value, record) => record.siraNo.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
          },
          {
            title: "İsim",
            dataIndex: "isim",
            key: "isim",
            filters: Helper.filter(esmaulHusnalar.items, "isim"),
            filteredValue: filteredInfo.isim || null,
            onFilter: (value, record) => record.isim.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
          },
          {
            title: "Anlamı",
            dataIndex: "anlami",
            key: "anlami",
            filters: Helper.filter(esmaulHusnalar.items, "anlami"),
            filteredValue: filteredInfo.anlami || null,
            onFilter: (value, record) => record.anlami.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
          },
          {
            title: "Not",
            dataIndex: "not",
            key: "not",
            filters: Helper.filter(esmaulHusnalar.items, "not"),
            filteredValue: filteredInfo.not || null,
            onFilter: (value, record) => record.not.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
          },
          {
            key: "action",
            render: (_, record) => (
              <Space size="middle">
                <Tooltip title="Düzenle">
                  <Button
                    onClick={() => handleEdit(record)}
                    type="primary"
                    shape="circle"
                    icon={<EditOutlined />}
                  />
                </Tooltip>
                <Popconfirm
                  title="İsmi Silmek İstediğinize Emin Misiniz ?"
                  onConfirm={() => handleDelete(record.id)}
                  okText="Evet"
                  cancelText="Hayır"
                >
                  <Tooltip title="Sil">
                    <Button
                      type="primary"
                      danger
                      shape="circle"
                      icon={<DeleteOutlined />}
                    />
                  </Tooltip>
                </Popconfirm>
              </Space>
            ),
          },
        ]}
      />

      <Modal
        title="Ekle"
        onCancel={handleCancel}
        visible={isModalVisible}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Vazgeç
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={esmaulHusna.loading}
            onClick={handleOk}
          >
            Kaydet
          </Button>,
        ]}
      >
        <Form
          name="basic"
          form={form}
          labelCol={{
            span: 6,
          }}
          initialValues={{ remember: true }}
          autoComplete="on"
        >
          <Form.Item hidden={true} name="id">
            <Input />
          </Form.Item>
          <Form.Item
            label="İsim"
            name="isim"
            rules={[{ required: true, message: "İsim boş geçilemez" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Sıra"
            name="siraNo"
            rules={[{ required: true, message: "Sıra boş geçilemez" }]}
          >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item
            label="Anlamı"
            name="anlami"
            rules={[{ required: true, message: "Anlamı boş geçilemez" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Not" name="not">
            <TextArea rows={4} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default EsmaulHusnalar;
